/**
 * PURPOSE: Badge ultra compacto de estado de conexión del visualizador.
 * ROUTE: src/pages/VolleyballViewer/components/ViewerConnectionBadge.jsx
 */

const META = {
  connected: ["Conectado", "bg-emerald-100 text-emerald-800 border-emerald-200"],
  syncing: ["Sync", "bg-sky-100 text-sky-800 border-sky-200"],
  connecting: ["Conectando", "bg-amber-100 text-amber-800 border-amber-200"],
  reconnecting: ["Reconectando", "bg-orange-100 text-orange-800 border-orange-200"],
  stale: ["Último", "bg-slate-100 text-slate-700 border-slate-200"],
  disabled: ["Desactivado", "bg-rose-100 text-rose-800 border-rose-200"],
  officialized: ["Oficializado", "bg-purple-100 text-purple-800 border-purple-200"],
  kicked: ["Fuera", "bg-rose-100 text-rose-800 border-rose-200"],
  idle: ["Espera", "bg-slate-100 text-slate-700 border-slate-200"],
};

export default function ViewerConnectionBadge({ state }) {
  const [label, cls] = META[state] || META.idle;
  return (
    <span className={`inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-[9px] font-black uppercase tracking-[0.06em] ${cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}
